"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const availablePos = {
    cursor: 'pointer'
};
const unavailablePos = {
    cursor: 'not-allowed'
};
const choosePosContainer = (theme) => ({
    display: 'grid',
    columnGap: 48,
    borderRadius: 10,
    padding: '0 48px',
    placeItems: 'center',
    justifyContent: 'center',
    height: 'calc(100vh - 190px)',
    boxShadow: '0px 0px 10px 0px #0000000D',
    gridTemplateColumns: '202px 202px 202px 202px',
    backgroundColor: theme === 'dark' ? '#272936' : constants_1.color.white,
});
exports.default = {
    availablePos,
    unavailablePos,
    choosePosContainer
};
